import React from "react";
import { Link } from "react-router-dom";
import "./nlyLogoname.css";
import logo from "./Images/logo_bg1.png";

export default function OnlyLogoname() {
    return (
        <div className="nly-desktop-logo">
            <Link to="/" className="nly-desktop-logo-link">
                <div className="nly-desktop-logo-image-wrapper">
                    <img
                        src={logo}
                        alt="BG RealEstate360 Logo"
                        className="nly-desktop-logo-image"
                    />
                </div>

                <div className="nly-desktop-logo-text-container">
                    <h1 className="nly-desktop-company-name">BG RealEstate360</h1>
                    <p className="nly-desktop-company-tagline">
                        Industrial & Land Experts
                    </p>
                    <span className="nly-desktop-industry-badge">Est. 2001</span>
                </div>
            </Link>
        </div>
    );
}